import { ReactNode } from 'react';

type Props = {
  icon: ReactNode;
  children: ReactNode;
};

export const NarrativeCommunityHeaderInfoBlock = ({
  icon,
  children,
}: Props) => {
  return (
    <div
      role="listitem"
      className="grid gap-x1 grid-cols-[65px_auto] md:grid-cols-[85px_auto] items-center"
    >
      <div className="relative">
        <div className="absolute inset-3 lg:inset-1 bg-p-grey-10 blur-2xl" />
        <div className="z-10 relative">{icon}</div>
      </div>
      <p className="text-solid text-xs font-strong mb-0 text-pretty">
        {children}
      </p>
    </div>
  );
};
